import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './Components/PIM/common/pim-tokens.css';
import { PersistGate } from 'redux-persist/integration/react';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { Provider } from 'react-redux';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import reportWebVitals from './reportWebVitals';
import mainStore from './store/index';
import common_ge from './translations/ge/common.json';
import common_en from './translations/en/common.json';
import purchaseOrderEnglish from './translations/en/purchase-order.json';
import chatEn from './translations/en/modules/chat.json';
import chatGN from './translations/ge/modules/chat.json';
import myTodoEn from './translations/en/modules/my-todo.json';
import myTodoGe from './translations/ge/modules/my-todo.json';
import DamPreviewModalProvider from './Components/DamPreviewModal/ModalProvider';
import GoogleMapProvider from './Components/GoogleMapComponent/GoogleMapProvider';
import systemMasterEn from './translations/en/modules/system-master.json';
import systemMasterGe from './translations/ge/modules/system-master.json';
import dashboardEn from './translations/en/modules/dashboard.json';
import productSampleEn from './translations/en/product-sample.json';
import samplesEn from './translations/en/samples.json';
import sampleTypeGroupMasterEn from './translations/en/modules/sample-type-group-master.json';
import sampleTypeGroupMasterGe from './translations/ge/modules/sample-type-group-master.json';
import additionalVariablesMasterEn from './translations/en/modules/additional-variables-master.json';
import additionalVariablesMasterGe from './translations/ge/modules/additional-variables-master.json';
import colourGroupEn from './translations/en/modules/colourGroup.json';
import assetLibraryHomeEn from './translations/en/modules/asset-library-home.json';
import costing_EN from './translations/en/modules/costing.json';
import account_EN from './translations/en/modules/accountDetails.json';
import partnerOverviewEn from './translations/en/modules/partner-overview.json';
import newConfirmationPopupEn from './translations/en/modules/new-confirmation-popup.json';
import assetLibraryAssetsEn from './translations/en/modules/asset-library-assets.json';
import pimEn from './translations/en/modules/pim.json';
import pimGe from './translations/ge/modules/pim.json';
import multiSubmitEn from './translations/en/modules/multi-submit.json';
import todoReportsEn from './translations/en/modules/todo-reports.json';
import ssoEn from './translations/en/modules/sso.json';

import confirmButtonPopup from './translations/en/modules/confirm-button-popup.json';
import bomEn from './translations/en/modules/bom.json';
import bulkEditEn from './translations/en/bulk-edit.json';
import careUserInstructionsEn from './translations/en/modules/care-user-instructions.json';
import designDetailsEn from './translations/en/modules/design-details.json';
import productInformationEn from './translations/en/product-information.json';
import designDetailEn from './translations/en/modules/design-detail.json';
import retailIdentifierColumnsEn from './translations/en/retail-identifier-columns.json';
import rangePlanProductIdentifierEn from './translations/en/range-plan-product-identifier.json';
import productIdentifierEn from './translations/en/product-identifier.json';
import specificationEn from './translations/en/modules/specification.json';
import placeholderManagementEn from './translations/en/modules/placeholder-management.json';
import retailIdentifierEn from './translations/en/modules/retail-identifier.json';
import freightEn from './translations/en/modules/freight.json';

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'en',
  fallbackLng: 'en',
  resources: {
    en: {
      common: common_en,
      'purchase-order': purchaseOrderEnglish,
      colourGroup: colourGroupEn,
      'new-confirmation-popup': newConfirmationPopupEn,
      'confirm-button-popup': confirmButtonPopup,
      'modules/chat': chatEn,
      'modules/my-todo': myTodoEn,
      'modules/partner-overview': partnerOverviewEn,
      sampleTypeGroupMaster: sampleTypeGroupMasterEn,
      systemMaster: systemMasterEn,
      'product-sample': productSampleEn,
      additionalVariablesMaster: additionalVariablesMasterEn,
      'modules/dashboard': dashboardEn,
      assetLibraryHome: assetLibraryHomeEn,
      assetLibraryAssets: assetLibraryAssetsEn,
      samples: samplesEn,
      costing: costing_EN,
      account: account_EN,
      pim: pimEn,
      'todo-reports': todoReportsEn,
      'modules/bom': bomEn,
      'modules/multi-submit': multiSubmitEn,
      'bulk-edit': bulkEditEn,
      sso: ssoEn,
      'modules/care-user-instructions': careUserInstructionsEn,
      'modules/design-details': designDetailsEn,
      'product-information': productInformationEn,
      'modules/design-detail': designDetailEn,
      retailIdentifierColumns: retailIdentifierColumnsEn,
      rangePlanProductIdentifier: rangePlanProductIdentifierEn,
      productIdentifier: productIdentifierEn,
      specification: specificationEn,
      'modules/placeholder-management': placeholderManagementEn,
      'modules/retail-identifier': retailIdentifierEn,
      'modules/freight': freightEn,
    },
    ge: {
      common: common_ge,
      'modules/chat': chatGN,
      'modules/my-todo': myTodoGe,
      sampleTypeGroupMaster: sampleTypeGroupMasterGe,
      systemMaster: systemMasterGe,
      additionalVariablesMaster: additionalVariablesMasterGe,
      pim: pimGe,
    },
  },
});
const rootElement = document.getElementById('root');

const renderApp = () => (
  <Provider store={mainStore.store}>
    <PersistGate loading={null} persistor={mainStore.persistor}>
      <I18nextProvider i18n={i18next}>
        <DamPreviewModalProvider>
          <GoogleMapProvider>
            <App />
          </GoogleMapProvider>
        </DamPreviewModalProvider>
      </I18nextProvider>
    </PersistGate>
  </Provider>
);
const rootComponent = process.env.NODE_ENV === 'development' ? <React.StrictMode>{renderApp()}</React.StrictMode> : renderApp();

ReactDOM.render(rootComponent, rootElement);
reportWebVitals();
